import { render, staticRenderFns } from "./StartYourJourneyForFreeV2.vue?vue&type=template&id=212aa94b&"
import script from "./StartYourJourneyForFreeV2.vue?vue&type=script&lang=js&"
export * from "./StartYourJourneyForFreeV2.vue?vue&type=script&lang=js&"
import style0 from "./StartYourJourneyForFreeV2.vue?vue&type=style&index=0&id=212aa94b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports